import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type { ApiResponse } from '@/types';
import { useAuthStore } from '@/stores/authStore';

export const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ code: number; message: string }>) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearAuth();
      window.location.href = '/login';
    }
    const message = error.response?.data?.message || error.message || '请求失败';
    return Promise.reject(new Error(message));
  },
);

export function unwrap<T>(response: AxiosResponse<ApiResponse<T>>): T {
  const payload = response.data;
  if (payload.code !== 0 && payload.code !== 200) {
    throw new Error(payload.message || '请求失败');
  }
  return payload.data;
}

export async function apiRequest<T>(config: AxiosRequestConfig): Promise<T> {
  const response = await apiClient.request<ApiResponse<T>>(config);
  return unwrap(response);
}
